import { x508 } from '../app/x508';


// Escapes a string for safe HTML insertion (prevents XSS via text reinterpreted as HTML).
function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
// The following code is used to make our search term bold.
// http://stackoverflow.com/a/9795091
$.fn.wrapInTag = function (opts) {
  // http://stackoverflow.com/a/1646618
  function getText(obj) {
    return obj.textContent ? obj.textContent : obj.innerText;
  }

  var tag = opts.tag || 'strong',
      words = opts.words || [],
      regex = RegExp(words.join('|'), 'gi'),
      replacement = '<' + tag + '>$&</' + tag + '>';

  // http://stackoverflow.com/a/298758
  $(this).contents().each(function () {
    if (this.nodeType === 3) //Node.TEXT_NODE
    {
      $(this).empty().replaceWith(getText(this).replace(regex, replacement));
    }
    else if (!opts.ignoreChildNodes) {
      $(this).wrapInTag(opts);
    }
  });
};

// This bit of sadness helps prevent unexpected openings of the searchbox.
let keysThatShouldNotOpenSearch = [
  'Meta',
  'Enter',
  'Shift',
  'Alt',
  'Tab',
  'Escape',
  'Control',
  'CapsLock',
  'ContextMenu',
  'NumLock',
  'ScrollLock',
  'AudioVolumeMute',
  'AudioVolumeDown',
  'AudioVolumeUp',
  'LaunchMediaPlayer',
  'LaunchApplication1',
  'LaunchApplication2',
  'Print',
  'Insert',
  'Home',
  'End',
  'Paused',
  'F1',
  'F2',
  'F3',
  'F4',
  'F5',
  'F6',
  'F7',
  'F8',
  'F9',
  'F10',
  'F11',
  'F12',
];

var DynamicSearch = (function ($) {
  var dynamic_menu_height = 250;

  function instantiate() {
    function precreateListboxForStaticScanners(inputNode) {
      const id = inputNode.attr('aria-controls');
      if (!id) return null;
      const existing = $(`#${id}`);
      if (existing.length > 0) {
        return existing.hide().empty();
      }
      const listbox = $(`<ul id='${id}' class='hover_menu' role='listbox' aria-label='Healthcare Specialties. Press Tab to traverse these list items' tabindex="-1" style="display:none;"/>`);
      inputNode.parent().append(listbox);
      return listbox;
    }

    var me = new Object();

    function strengthen_tokens_in_html(token, html) {
      var regex = new RegExp(token, 'gi');
      return html.replace(regex, '<strong>$&</strong>');
    }

    me.init = function (node) {
      if ($(node).data('already-dynamic') !== undefined) {
        return;
      }
      me.node = $(node);
      me.ornament_node = $(me.node.siblings('.input-group-prepend').find('.input-group-text'));
      me.node.data('already-dynamic', true);
      me.hover_menu_container = null;
      me.hover_menu_is_open = false;
      me.hover_menu_id = me.node.attr('aria-controls');
      me.url = me.node.data('dynamic-search-url');

      me.hover_menu_container = precreateListboxForStaticScanners(me.node);
      me.xhr_type = me.node.data('dynamic-search-type');
      if (me.xhr_type === undefined) {
        me.xhr_type = 'json';
      }
      me.search_callback_timer = null;

      me.search_callback = function (data, textStatus, jqXHR) {
        if (me.xhr_type !== 'json') {
          //render template!
          var offset = me.node.offset();
          offset.top = offset.top + me.node.height() + 10;
          me.create_hover_menu_at_position(offset);
          me.hover_menu_container.append(data);
          me.hover_menu_is_open = true;
          me.node.attr('aria-expanded', true);
          me.hover_menu_container.css({'height':'auto'});
          var menu_height = me.hover_menu_container.height();
          if (menu_height > dynamic_menu_height) {
            me.hover_menu_container.css({'height':dynamic_menu_height});
          }
        } else {
          // Here be dragons!
          var offset = me.node.offset();
          me.hover_menu_is_open = true;
          me.node.attr('aria-expanded', true);
          offset.top = offset.top + me.node.height() + 10;
          me.create_hover_menu_at_position(offset);

          // Build grouped results, but generate LOCAL-only anchors.
          // We avoid remote assign here and defer persistence until the modal form submits.
          var html, menu_height;
          for (var parent_group_label_key in data) {
            let item_array = data[parent_group_label_key];
            let item_array_key_title_id = parent_group_label_key
              .replaceAll(" ", "")
              .replaceAll("&", "")
              .toLowerCase();

            if (item_array.length > 0) {
              html = `<li><span id='section_${item_array_key_title_id}'>${parent_group_label_key}</span><ul>`;
              item_array.forEach((item) => {
                const item_html = `
                  <li id='healthcare_specialty_item_${item.id}' class='healthcare_specialty_item' aria-describedby="section_${item_array_key_title_id}">
                    <a href='#' role="option" data-specialty-id='${item.id}'>${item.title}</a>
                  </li>
                `;
                html += item_html;
              });

              html = html + "</ul></li>";
              me.append_list_items_to_menu(menu_height, html);
            }
          }

          if (Object.keys(data).length === 0) {
            html = '<li><span id="section_no_results" class="specialty-no-results" role="status">No results found</span><ul>';
            me.append_list_items_to_menu(menu_height, html);
          }
        }
      };

      me.adjust_menu_height = function (menu_height) {
        me.hover_menu_container.css({ 'height': 'auto' });
        menu_height = me.hover_menu_container.height();
        if (menu_height > dynamic_menu_height) {
          me.hover_menu_container.css({ 'height': dynamic_menu_height });
        }
      };

      me.append_list_items_to_menu = function (menu_height, html) {
        me.hover_menu_container.append(html);
        if (me.node.val().length > 0) {
          me.hover_menu_container.wrapInTag({ words: [me.node.val()] });
        }

        me.adjust_menu_height(menu_height);
      };

      me.remove_hover_menu = function () {
        if (me.hover_menu_container !== null) {
          me.hover_menu_container.remove();
          me.hover_menu_container = null;
          me.hover_menu_is_open = false;
          me.node.attr('aria-expanded', false);
        }
      };

      me.create_hover_menu_at_position = function (point) {
        me.remove_hover_menu();
        me.hover_menu_container = $(
          `<ul id='${me.hover_menu_id}' class='hover_menu' role='listbox' aria-label='Healthcare Specialties. Press Tab to traverse these list items' tabindex="-1"/>`
        );
        me.node.parent().append(me.hover_menu_container);
        me.node.attr('aria-controls', me.hover_menu_id);
        me.hover_menu_container.css(
          {
            'position':'absolute',
            'top':'100%',
            'left':0,
            'width':'100%',
            'height':dynamic_menu_height + 'px'
          }
        );
        me.hover_menu_is_open = true;
        me.node.attr('aria-expanded', true);
        me.setup_menu_removal_button();

        me.hover_menu_container.on('keydown', function (event) {
          if (event.code === 'Escape') {
            event.stopPropagation();
            me.close_search(event);
            me.node.focus();
          }
        });

        // set the focus to the hover_menu_container ONLY IF the use is not typing
        const inputField = document.getElementById('input-health-care-specialties');
        if (document.activeElement !== inputField) {
          me.hover_menu_container.focus();
        }
      };

      me.setup_menu_removal_button = function () {
        var html = '<button type="button" class="border-0 px-0" aria-label="Close healthcare specialty selection"><i class="fa fa-times-circle" aria-hidden="true"></i></button>';
        me.ornament_node.html(html);
        me.ornament_node.on('click', function (event) {
          me.close_search(event);
          me.node.focus();
        });
      };

      me.close_search = function (event) {
        event.preventDefault();
        me.ornament_node.html('<i class="fa fa-search" aria-hidden="true"></i>');
        me.remove_hover_menu();
        me.hover_menu_is_open = false;
        me.node.attr('aria-expanded', false);
        me.node.val('');
      };

      //cycle forwards
      me.next_listitem = function() {
        if(me.hover_menu_container != null){
          var listitems = me.hover_menu_container.find('li.healthcare_specialty_item');
          me.cycle_next(listitems);
        }
      };

      //cycle backwards.
      me.previous_listitem = function() {
        if(me.hover_menu_container != null){
          var listitems = me.hover_menu_container.find('li.healthcare_specialty_item');
          me.cycle_next(listitems.toArray().reverse());
        }
      };

      me.click_simulated_hover = function() {
        if(me.hover_menu_container != null){
          var items = me.hover_menu_container.find('li.healthcare_specialty_item.simulate_hover');
          if (items.length > 0) {
            let relatedLink = $(items).find('a');
            relatedLink.triggerHandler('click');
            x508.say(`${relatedLink.text()} added as a selected healthcare specialty`);
          }
        }
      };

      me.cycle_next = function (listitems) {
        for (let i = 0; i <= listitems.length; i++){
          if ($(listitems[i]).hasClass('simulate_hover')) {
            if (i < listitems.length) {
              $(listitems[i]).removeClass('simulate_hover');
              $(listitems[i]).removeAttr('aria-selected');

              let next_item;
              if (listitems[i + 1]) {
                next_item = listitems[i + 1];
              } else {
                next_item = listitems[0];
              }

              if (next_item) {
                //scroll in list box.
                me.update_hover_menu_animation(next_item);
              }
              return;
            }
          }
        }

        //couldn't find simulate_hover so it to the first item.
        if (listitems.length >= 0) {
          me.update_hover_menu_animation(listitems[0]);
        }
      };

      me.update_hover_menu_animation = function (focusedMenuItem) {
        focusedMenuItem = $(focusedMenuItem);
        focusedMenuItem.addClass('simulate_hover');
        focusedMenuItem.attr('aria-selected', true);
        me.node.attr('aria-activedescendant', focusedMenuItem.attr('id'));

        me.hover_menu_container.animate({
          scrollTop: focusedMenuItem.offset().top - me.hover_menu_container.offset().top + me.hover_menu_container.scrollTop() - 20
        });
      };

      $(me.node).on('keydown', function (event) {
        // Handle most events in keyup but some you have to bind to key down.
        if(event.code == 'Enter') { //prevent form submit while trying to add item.
          event.stopPropagation();
          event.preventDefault();
          return false;
        }
      });

      $(me.node).on('keyup', function (event) {
        if ($(event.target).data('dynamic-search-url') === undefined) {
          return;
        }

        if (!me.hover_menu_is_open) {
          if (event.code == 'Escape') { //escape key close the menu.
            me.node.val('');
          }

          if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {
            $.post(me.url, { browse_all: 'true' }, me.search_callback, 'json').done(function () {
              if (event.altKey) {
                return;
              }

              if (event.code == 'ArrowUp') {
                me.previous_listitem();
              } else {
                me.next_listitem();
              }
            });
          }
        }

        if (event.code == 'Escape') { //escape key close the menu.
          me.node.trigger('dynamic_menu:close');
          return;
        }

        if (event.code == 'ArrowDown') { //down arrow
          me.next_listitem();
          return;
        }

        if (event.code == 'ArrowUp') { //up arrow
          me.previous_listitem();
          return;
        }

        if(event.code == 'Enter') { //enter key
          if (me.hover_menu_is_open) {
            event.stopPropagation();
            event.preventDefault();
            me.click_simulated_hover();

            me.close_search(event);
            me.node.focus();
            return false;
          }
        }

        // We want to delay the search long enough that it only searches when there is a pause in the typing, but we want it to still be responsive.
        // two-tenths of a second is about 60 wpm, anyone typing below that is going to generate hella network requests. (up to 6 per second).
        if (keysThatShouldNotOpenSearch.indexOf(event.key) !== -1) {
          return;
        }

        clearTimeout(me.search_callback_timer);
        me.search_callback_timer = setTimeout(function () {
          $.post(me.url, {'search_token': event.target.value}, me.search_callback, me.xhr_type);
        }, 200);
      });

      $('.healthcare_specialty_browse_all').on('click', function (event) {
        event.preventDefault();
        me.node.val('');

        $(this).attr('aria-expanded', !me.hover_menu_is_open);

        if (!me.hover_menu_is_open) {
          $.post(me.url, { browse_all: 'true' }, me.search_callback, 'json');
        } else {
          me.close_search(event);
        }
      });

      $(document).on('dynamic_menu:refocus_on_input', function () {
        me.node.focus();
      });

      $(document).on('dynamic_menu:close', function (event) {
        if (!me.node.is(':visible')) {
          return;
        }

        me.close_search(event);
      });

      $(document).on('hide', function () {
        $(document).trigger('dynamic_menu:close');
      });
    };

    return me;
  }

  return {
    instantiate:instantiate
  };
})($);

function ensureSelectedContainer($fromEl) {
  var $container = $('.healthcare_specialty_container ul').first();
  if (!$container.length) {
    var $inputGroup = $fromEl.closest('.input-group');
    $container = $('<ul></ul>');
    if ($inputGroup.length) {
      $inputGroup.after($container);
    } else {
      $fromEl.after($container);
    }
  }
  return $container;
}

function addSelectedChip($fromEl, id, title) {
  var $container = ensureSelectedContainer($fromEl);
  if ($container.find('li[data-specialty-id="' + id + '"]').length) { return; }

  var escapedTitle = escapeHtml(title);
  var isFirst = $container.find('li').length === 0;
  var primeClass = isFirst ? ' prime' : '';

  var imagePaths = getStarImagePaths();
  var primaryStarSrc = imagePaths.primary || '';
  var secondaryStarSrc = imagePaths.secondary || '';

  if (!secondaryStarSrc && primaryStarSrc) {
    secondaryStarSrc = primaryStarSrc.replace(/primary_specialty/g, 'specialty');
  }
  if (!primaryStarSrc && secondaryStarSrc) {
    primaryStarSrc = secondaryStarSrc.replace(/specialty/g, 'primary_specialty');
  }

  // Both branches render a button so the star is reachable and named for screen
  // readers. The primary one is aria-disabled: it stays in the tab order and
  // announces its state instead of being an unlabelled image.
  var crownHtml = isFirst
    ? '<span class="crown_icon"><button type="button" class="crown_new_specialty" aria-disabled="false" data-specialty-id="' + id + '" aria-label="' + escapedTitle + ' is the primary healthcare specialty"><img src="' + primaryStarSrc + '" alt="The primary healthcare specialty"></button></span>'
    : '<span class="crown_icon"><button type="button" class="crown_new_specialty" aria-disabled="true" data-specialty-id="' + id + '" aria-label="Make ' + escapedTitle + ' the primary healthcare specialty"><img src="' + secondaryStarSrc + '" alt="Make ' + escapedTitle + ' the primary healthcare specialty"></button></span>';

  var $chip = $(`
    <li class="${primeClass}" data-specialty-id="${id}">
      ${crownHtml}
      <span class="title">${escapedTitle}</span>
      <span class="removal_icon">
        <button type="button" class="remove_healthcare_specialty" data-specialty-id="${id}" aria-label="Remove ${escapedTitle}">
          <i class="fa fa-times-circle remove_healthcare_specialty_close" aria-hidden="true"></i>
        </button>
      </span>
    </li>
  `);
  $container.append($chip);
}

function setHiddenIds($hidden, ids) {
  $hidden.val(ids.join(','));
}

function inDeferContext(el) {
  var $el = $(el);
  return $el.closest('.modal, form').find('#user_healthcare_specialty_ids').length > 0;
}

// Focus an element without scroll-jumping the demographics modal.
function safeFocus($el) {
  var el = $el && $el[0];
  if (!el) { return; }

  try {
    el.focus({ preventScroll: true });
  } catch (_) {
    el.focus();
  }
}

// The Remove button sits inside the specialty item it deletes, so focus drops to
// <body> once that item is gone. Resolve the next logical target while the item is
// still in the DOM. Returns an empty set when nothing is left to focus.
function removalFocusTarget($item) {
  var removeControls = '.remove_healthcare_specialty, .remove-selected-specialty';

  var $next = $item.nextAll().find(removeControls).filter(':visible').first();
  if ($next.length) { return $next; }

  return $item.prevAll().find(removeControls).filter(':visible').first();
}

function removeIdFromHidden(id) {
  var $hidden = $('#user_healthcare_specialty_ids');
  var ids = ($hidden.val() || '')
    .split(',')
    .map(Number)
    .filter(Boolean)
    .filter(function (n) { return n !== id; });

  setHiddenIds($hidden, ids);
}

function seedHiddenFromServerListIfEmpty() {
  var $hidden = $('#user_healthcare_specialty_ids');
  if (($hidden.val() || '').trim()) { return; }

  // Try data attribute first; fall back to parsing the retract URL.
  var ids = $('.remove_healthcare_specialty')
    .map(function (_, el) {
      var dataId = Number(el.getAttribute('data-specialty-id'));
      if (dataId) { return dataId; }
      var href = el.getAttribute('href') || '';
      var m = href.match(/healthcare_specialties\/(\d+)/);
      return m ? Number(m[1]) : null;
    })
    .get()
    .filter(Boolean);

  if (ids.length) { setHiddenIds($hidden, Array.from(new Set(ids))); }

  // Also seed primary specialty if not set
  var $primaryHidden = $('#user_primary_healthcare_specialty_id');
  if (!($primaryHidden.val() || '').trim()) {
    var $primeLi = $('li.prime').first();
    if ($primeLi.length) {
      var primaryId = $primeLi.find('.remove_healthcare_specialty').data('specialty-id');
      if (primaryId) {
        $primaryHidden.val(primaryId);
      }
    }
  }
}

// Helper function to get the correct image paths from existing elements
function getStarImagePaths() {
  var primaryStarImage = null;
  var secondaryStarImage = null;

  // Try to find existing images to extract the correct asset paths
  // Search in both modal and main container
  var $container = $('#edit_demographics_modal, .healthcare_specialty_container, .healthcare-specialty, .new-demographics');

  if ($container.length) {
    // First, check the hidden reference images that always exist
    var $refContainer = $container.find('[data-specialty-image-refs]');
    if ($refContainer.length) {
      var $refImgs = $refContainer.find('img');
      $refImgs.each(function() {
        var src = $(this).attr('src');
        if (src && src.indexOf('primary_specialty') !== -1) {
          primaryStarImage = src;
        } else if (src && src.indexOf('specialty') !== -1 && src.indexOf('primary_specialty') === -1) {
          secondaryStarImage = src;
        }
      });
    }

    // If still missing, look for existing specialty list items
    if (!secondaryStarImage) {
      var $secondaryImg = $container.find('li:not(.prime) .crown_icon button img, li:not(.prime) .crown_icon img').first();
      if ($secondaryImg.length) {
        secondaryStarImage = $secondaryImg.attr('src');
      }
    }

    if (!primaryStarImage) {
      var $primaryImg = $container.find('li.prime .crown_icon img').first();
      if ($primaryImg.length) {
        primaryStarImage = $primaryImg.attr('src');
      }
    }

    // Fallback: try the disclaimer image which always has primary_specialty
    if (!primaryStarImage) {
      var $disclaimerImg = $container.find('.specialty_disclaimer img').first();
      if ($disclaimerImg.length) {
        primaryStarImage = $disclaimerImg.attr('src');
      }
    }
  }

  // If we found both from the DOM, return them
  if (primaryStarImage && secondaryStarImage) {
    return {
      primary: primaryStarImage,
      secondary: secondaryStarImage
    };
  }

  // Fallback: try to detect from the filename pattern
  if (!primaryStarImage || !secondaryStarImage) {
    var $anyImg = $container.find('.crown_icon img, .specialty_disclaimer img').first();
    if ($anyImg.length) {
      var src = $anyImg.attr('src');
      // If we have one, we can infer the other by pattern matching
      if (src && src.indexOf('primary_specialty') !== -1) {
        primaryStarImage = primaryStarImage || src;
        // Replace primary_specialty with specialty, handling both plain and hashed filenames
        // e.g. primary_specialty-abc123.png -> specialty-abc123.png
        secondaryStarImage = secondaryStarImage || src.replace(/primary_specialty(-[a-f0-9]+)?\.png/, 'specialty$1.png');
      } else if (src && src.indexOf('specialty') !== -1 && src.indexOf('primary_specialty') === -1) {
        secondaryStarImage = secondaryStarImage || src;
        // Replace specialty with primary_specialty, handling both plain and hashed filenames
        // e.g. specialty-abc123.png -> primary_specialty-abc123.png
        primaryStarImage = primaryStarImage || src.replace(/specialty(-[a-f0-9]+)?\.png/, 'primary_specialty$1.png');
      }
    }
  }

  return {
    primary: primaryStarImage,
    secondary: secondaryStarImage
  };
}

/* ---------------------------------------------------------------------
   Wire-up
   --------------------------------------------------------------------- */

function setUpTheDynamicSearchInstance() {
  $('[data-dynamic-search-url]').each(function () {
    DynamicSearch.instantiate().init($(this));
  });

  // Add from search results — LOCAL ONLY (no remote request here)
  $(document).off('click.deferSave', 'li.healthcare_specialty_item a');
  $(document).on('click.deferSave', 'li.healthcare_specialty_item a', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    var $a = $(this);
    var id = Number($a.data('specialty-id'));
    if (!id) { return; }

    var $hidden = $('#user_healthcare_specialty_ids');
    var current = ($hidden.val() || '').trim();
    var ids = current ? current.split(',').map(Number).filter(Boolean) : [];

    var isFirstSpecialty = ids.length === 0;

    if (ids.indexOf(id) === -1) {
      ids.push(id);
      setHiddenIds($hidden, ids);
    }

    // Set as primary if it's the first specialty being added
    var $primaryHidden = $('#user_primary_healthcare_specialty_id');
    if (isFirstSpecialty && !($primaryHidden.val() || '').trim()) {
      $primaryHidden.val(id);
    }

    addSelectedChip($a, id, $a.text().trim());
    $a.closest('li').addClass('selected');

    $(document).trigger('dynamic_menu:close');
    $(document).trigger('dynamic_menu:refocus_on_input');
    x508.say($a.text().trim() + ' added as a selected healthcare specialty');
  });

  // Remove from chips OR server-rendered list — LOCAL ONLY (block remote)
  $(document).off('click.deferRemove', '.remove-selected-specialty, .remove_healthcare_specialty');
  $(document).on('click.deferRemove', '.remove-selected-specialty, .remove_healthcare_specialty', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    // Resolve id from data attribute or from the retract URL
    var id = Number($(this).data('specialty-id'));
    if (!id) {
      var href = this.getAttribute('href') || '';
      var m = href.match(/healthcare_specialties\/(\d+)/);
      id = m ? Number(m[1]) : 0;
    }
    if (!id) { return; }

    var $item = $(this).closest('li.selected-healthcare-specialty, li');
    var title = $item.find('.badge').text().trim() || $item.find('.title').text().trim();

    // Check if we're removing the primary specialty
    var wasRemovingPrimary = $item.hasClass('prime');

    // Get image paths BEFORE removing the item (while DOM still has examples)
    var imagePaths = getStarImagePaths();

    // Resolve this BEFORE removal, for the same reason as the image paths above.
    var $focusTarget = removalFocusTarget($item);

    removeIdFromHidden(id);
    $item.remove();

    if (typeof x508?.say === 'function') {
      x508.say((title || 'Specialty') + ' removed from selected healthcare specialties');
    }

    // If we removed the primary specialty, promote the next one
    if (wasRemovingPrimary) {
      // Find remaining specialty items in the modal
      var $modal = $('#edit_demographics_modal');
      if ($modal.length > 0) {
        var $remainingItems = $modal.find('li').has('.remove_healthcare_specialty');

        if ($remainingItems.length > 0) {
          // Get the first remaining item
          var $newPrimary = $remainingItems.first();
          var newPrimaryId = $newPrimary.find('.remove_healthcare_specialty').data('specialty-id');

          // Update hidden field
          $('#user_primary_healthcare_specialty_id').val(newPrimaryId);

          // Add prime class
          $newPrimary.addClass('prime');

          // Change to primary star
          var $img = $newPrimary.find('.crown_icon img');
          if (imagePaths.primary) {
            $img.attr('src', imagePaths.primary);
          }
          $img.attr('alt', 'The primary healthcare specialty');
        } else {
          // No specialties left, clear the primary hidden field
          $('#user_primary_healthcare_specialty_id').val('');
        }
      }
    }

    if ($focusTarget.length) {
      safeFocus($focusTarget);
    } else {
      // That was the last specialty, so there is no sibling to land on. Go back to
      // the search input, matching the unassign path further down this file.
      $(document).trigger('dynamic_menu:refocus_on_input');
    }
  });

  document.addEventListener('click', function(event) {
    var $target = $(event.target);
    var $crownIcon = $target.closest('.crown_icon');

    if ($crownIcon.length === 0) {
      return; // Not a crown icon click
    }

    // Check if we're in the modal
    var $modal = $crownIcon.closest('#edit_demographics_modal');
    if ($modal.length === 0) {
      return; // Not in the modal, let it proceed normally
    }

    // STOP the event from propagating to other handlers (prevents AJAX)
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    // Find the list item and get the specialty ID
    var $li = $crownIcon.closest('li');
    var specialtyId = $li.find('.remove_healthcare_specialty').data('specialty-id');

    if (!specialtyId) {
      console.warn('Could not extract specialty ID from crown icon click');
      return false;
    }

    // Store in hidden field for later submission
    $('#user_primary_healthcare_specialty_id').val(specialtyId);

    // Find the parent list
    var $parentList = $li.parent();

    // FIXED: Find all healthcare specialty list items within the same parent
    var $allSpecialtyItems = $parentList.find('li').has('.remove_healthcare_specialty');

    // Get image paths dynamically from existing elements
    var imagePaths = getStarImagePaths();

    // Step 1: Remove 'prime' class from ALL items and change to secondary star
    $allSpecialtyItems.each(function() {
      var $item = $(this);
      $item.removeClass('prime');

      var $img = $item.find('.crown_icon img');
      if (imagePaths.secondary) {
        $img.attr('src', imagePaths.secondary);
      }

      // Update alt text to reflect it's now a secondary specialty
      var titleText = $item.find('.title').clone().children().remove().end().text().trim();
      var subspecialtyText = $item.find('.subspecialty').text().trim();
      var fullTitle = subspecialtyText ? titleText + ' ' + subspecialtyText : titleText;
      $img.attr('alt', 'Make ' + fullTitle + ' the primary healthcare specialty');
    });

    // Step 2: Add 'prime' class to clicked item and change to primary star
    $li.addClass('prime');

    var $clickedImg = $li.find('.crown_icon img');
    if (imagePaths.primary) {
      $clickedImg.attr('src', imagePaths.primary);
    }
    $clickedImg.attr('alt', 'The primary healthcare specialty');

    // Step 3: Move the clicked item to the top of the list
    $li.detach().prependTo($parentList);

    // Step 4: UPDATE THE HIDDEN FIELD with new order
    var $hiddenField = $('#user_healthcare_specialty_ids');
    var newOrder = [];
    $parentList.find('li').has('.remove_healthcare_specialty').each(function() {
      var id = $(this).find('.remove_healthcare_specialty').data('specialty-id');
      if (id) {
        newOrder.push(id);
      }
    });
    $hiddenField.val(newOrder.join(','));

    // Provide accessibility feedback
    if (typeof x508?.say === 'function') {
      var titleEl = $li.find('.title').first();
      var title = titleEl.clone().children().remove().end().text().trim();
      var subspecialty = titleEl.find('.subspecialty').text().trim();
      var fullTitle = subspecialty ? title + ' ' + subspecialty : title;
      x508.say(fullTitle + ' will be set as primary specialty when form is submitted');
    }

    return false;
  }, true); // TRUE = use capture phase

  // Intercept any legacy remote anchors in the modal and handle them locally
  $(document).off('click.deferBlock', 'a[data-remote][href*="/healthcare_specialties/"]');
  $(document).on('click.deferBlock', 'a[data-remote][href*="/healthcare_specialties/"]', function (event) {
    if (!inDeferContext(this)) { return; }

    event.preventDefault();
    event.stopImmediatePropagation();

    var href = this.getAttribute('href') || '';
    var id = Number($(this).data('specialty-id'));
    if (!id) {
      var m = href.match(/healthcare_specialties\/(\d+)/);
      id = m ? Number(m[1]) : 0;
    }
    if (!id) { return; }

    if (/\/assign(?:\?|$)/.test(href)) {
      var $hidden = $('#user_healthcare_specialty_ids');
      var current = ($hidden.val() || '').trim();
      var ids = current ? current.split(',').map(Number).filter(Boolean) : [];
      if (ids.indexOf(id) === -1) {
        ids.push(id);
        setHiddenIds($hidden, ids);
      }
      var title = $(this).text().trim();
      addSelectedChip($(this), id, title);
      x508.say(title + ' added as a selected healthcare specialty');
    } else if (/\/unassign|\/retract(?:\?|$)/.test(href)) {
      removeIdFromHidden(id);
      $('li.selected-healthcare-specialty[data-id="' + id + '"]').remove();
      $(this).closest('li').remove();
      x508.say('Removed selected healthcare specialty');
    }

    $(document).trigger('dynamic_menu:close');
    $(document).trigger('dynamic_menu:refocus_on_input');
  });

  // Keep Escape behavior as before
  $('li.healthcare_specialty_item a').off('keyup.deferEsc').on('keyup.deferEsc', function (event) {
    if (event.key === 'Escape') {
      $(document).trigger('dynamic_menu:close');
      $(document).trigger('dynamic_menu:refocus_on_input');
    }
  });

  $(document).on('click', 'a.pp_person', function () {
    $(document).trigger('dynamic_menu:close');
  });

  // Store original values when modal opens
  $(document).off('show.bs.modal', '#edit_demographics_modal');
  $(document).on('show.bs.modal', '#edit_demographics_modal', function () {
    var $modal = $(this);
    var $specialtyHidden = $('#user_healthcare_specialty_ids');
    var $primaryHidden = $('#user_primary_healthcare_specialty_id');

    // Store original values in data attributes
    $modal.data('original-specialty-ids', $specialtyHidden.val());
    $modal.data('original-primary-id', $primaryHidden.val());

    // Store the original primary list item
    var $primeLi = $('li.prime').first();
    if ($primeLi.length) {
      $modal.data('original-prime-id', $primeLi.find('.remove_healthcare_specialty').data('specialty-id'));
    }
  });

  // Reset to original values when modal is closed without submitting
  $(document).off('hide.bs.modal', '#edit_demographics_modal');
  $(document).on('hide.bs.modal', '#edit_demographics_modal', function (e) {
    var $modal = $(this);

    // Check if form was submitted successfully
    // If not, reset to original values
    if (!$modal.data('form-submitted')) {
      var $specialtyHidden = $('#user_healthcare_specialty_ids');
      var $primaryHidden = $('#user_primary_healthcare_specialty_id');

      // Restore original values
      var originalSpecialtyIds = $modal.data('original-specialty-ids');
      var originalPrimaryId = $modal.data('original-primary-id');
      var originalPrimeId = $modal.data('original-prime-id');

      if (originalSpecialtyIds !== undefined) {
        $specialtyHidden.val(originalSpecialtyIds);
      }

      if (originalPrimaryId !== undefined) {
        $primaryHidden.val(originalPrimaryId);
      }

      // Get image paths dynamically
      var imagePaths = getStarImagePaths();

      // Restore visual state of prime
      if (originalPrimeId) {
        var $allItems = $modal.find('li').has('.remove_healthcare_specialty');

        // Set all to secondary stars
        $allItems.each(function() {
          var $item = $(this);
          $item.removeClass('prime');

          var $img = $item.find('.crown_icon img');
          if (imagePaths.secondary) {
            $img.attr('src', imagePaths.secondary);
          }

          // Update alt text
          var titleText = $item.find('.title').clone().children().remove().end().text().trim();
          var subspecialtyText = $item.find('.subspecialty').text().trim();
          var fullTitle = subspecialtyText ? titleText + ' ' + subspecialtyText : titleText;
          $img.attr('alt', 'Make ' + fullTitle + ' the primary healthcare specialty');
        });

        // Find and restore the original primary item
        var $originalPrimeLi = $allItems.filter(function() {
          return $(this).find('.remove_healthcare_specialty').data('specialty-id') == originalPrimeId;
        });

        if ($originalPrimeLi.length) {
          $originalPrimeLi.addClass('prime');

          // Set to primary star
          var $img = $originalPrimeLi.find('.crown_icon img');
          if (imagePaths.primary) {
            $img.attr('src', imagePaths.primary);
          }
          $img.attr('alt', 'The primary healthcare specialty');

          // Move it back to the top
          var $parentList = $originalPrimeLi.parent();
          $originalPrimeLi.detach().prependTo($parentList);
        }
      }

      // Clear any temporary chips that were added
      $('#selected_healthcare_specialties[data-defer-selected="true"]').remove();
    }

    // Clear the submitted flag and stored data for next time
    $modal.data('form-submitted', false);
    $modal.removeData('original-specialty-ids');
    $modal.removeData('original-primary-id');
    $modal.removeData('original-prime-id');
  });

  // Mark form as submitted when it successfully submits
  $(document).off('ajax:success', '#edit-demographics-form');
  $(document).on('ajax:success', '#edit-demographics-form', function () {
    $('#edit_demographics_modal').data('form-submitted', true);
  });

  // Initialize hidden field from existing server-rendered list once
  seedHiddenFromServerListIfEmpty();
}

$(function () {
  setUpTheDynamicSearchInstance();
});

$(document).on('ajaxComplete', function () {
  setUpTheDynamicSearchInstance();
  seedHiddenFromServerListIfEmpty();
});